import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const searchTxParams = 'sold|leased|sold-and-leased';
const searchIcsParams = 'industrial|office|shops';

const router = new Router({
  mode: 'history',
  base: '/ics/property/transaction/',
  routes: [
    {
      name: 'transaction',
      path: `/:p1(${searchIcsParams}|${searchTxParams})?/:p2(${searchTxParams})?`,
      props: route => ({
        queryKeyword: route.query.t,
        queryPisBldgId: route.query.pis_bldg_id,
      }),
      component: () => import('./search'),
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
